import React from 'react';
import scaleSize from '../../utils/scale-size';

export default ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(30)}
    height={scaleSize(30)}
    viewBox="0 0 48 48"
    className={className}
  >
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#FFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="8"
    >
      <path d="M4 4l40 40M44 4L4 44" />
    </g>
  </svg>
);
